export default __webpack_public_path__ + "static/media/ic-italic.f65624df.svg";